<app-generic-sidebar
  [initialCollapsed]="isCollapsed()"
  [sections]="menuSections"
  baseRoutePath="configuration"
  [isDisabledFn]="isRouteDisabled"
  (isCollapsedChange)="updateCollapsedState($event)"
  (homeNavigate)="navigateHome()" />
